import axiosApiInstance from '@/api/axios'
import {
  CompleteRecoveringRequestModel,
  ForgotPasswordModel,
  LoginModel,
  RegistrationModel,
} from './models/AuthModel'
import { setItem } from '@utils/persistanceStorage'
import { AxiosResponse } from 'axios'
import { TokenModel } from '@/core/services/Token/model/TokenModel'
import { ChangePasswordModel } from '../../../modules/AccountPage/models/UserModel'

class AuthService {
  async registration(data: RegistrationModel): Promise<AxiosResponse> {
    return await axiosApiInstance.post(`/Auth/Signup`, data)
  }

  async login(data: LoginModel): Promise<AxiosResponse<TokenModel>> {
    const res = await axiosApiInstance.post(`/Auth/Authorization`, data)
    const token: TokenModel = res.data

    if (token && token.access_token) {
      setItem('creds', data)
      setItem('token', token)
    }

    return res
  }

  async forgotPassword(email: ForgotPasswordModel): Promise<number> {
    const res = await axiosApiInstance.post<AxiosResponse>(
      `/Auth/Password/Recover`,
      email,
    )
    return res.status
  }

  async changePassword(data: ChangePasswordModel): Promise<number> {
    const res = await axiosApiInstance.post<AxiosResponse>(
      `/Auth/Password/Reset`,
      data,
    )
    return res.status
  }

  async completeRecoveringPassword(
    data: CompleteRecoveringRequestModel,
  ): Promise<number> {
    const res = await axiosApiInstance.post<AxiosResponse>(
      `/Auth/Password/CompleteRecovering`,
      data,
    )
    return res.status
  }
}

export default new AuthService()
